import { gql } from '@apollo/client'

const CONDITIONS_FRAGMENT = gql`
  fragment AncillaryConditionsFragment on AncillaryConditions {
    citySegments {
      destination {
        code
        id
        name
      }
      origin {
        code
        id
        name
      }
      routeServices {
        code
        id
      }
      segments {
        id
        destination {
          code
          id
          name
        }
        origin {
          code
          id
          name
        }
      }
    }
    salesChannels {
      id
      name
      country {
        code
        name
      }
    }
    seatsPrice {
      doubleDecker {
        fromLabel
        price
        toLabel
      }
      standard {
        fromLabel
        price
        toLabel
      }
    }
  }
`
export const GET_ANCILLARIES = gql`
  query GetAncillaries($input: AncillariesInput, $pagination: Pagination!) {
    ancillaries(input: $input, pagination: $pagination) {
      items {
        id
        company {
          id
          name
        }
        isEnabled
        label {
          text
          language
        }
        name
        price
        salesChannelsV2 {
          id
          name
        }
        conditions {
          ...AncillaryConditionsFragment
        }
        type
      }
      total
    }
  }
  ${CONDITIONS_FRAGMENT}
`

export const GET_ANCILLARY = gql`
  query GetAncillary($input: AncillaryInput!) {
    ancillary(input: $input) {
      id
      company {
        id
        name
      }
      isEnabled
      label {
        text
        language
      }
      name
      price
      salesChannelsV2 {
        id
        name
      }
      conditions {
        ...AncillaryConditionsFragment
      }
      type
    }
  }
  ${CONDITIONS_FRAGMENT}
`

export const GET_ADDON_SERVICES = gql`
  query GetAddonServices($limit: Int!, $page: Int!) {
    serviceFeeAddonRules(input: {}, pagination: { size: $limit, page: $page }) {
      total
      items {
        id
        company {
          id
          name
        }
        salesChannelsV2 {
          id
          name
        }
        confirmationModalities
        segments {
          id
          origin {
            id
            name
            code
          }
          destination {
            id
            name
            code
          }
        }
        isEnabled
      }
    }
  }
`

export const GET_COMPANY_INSURANCE_SETTINGS = gql`
  query GetCompanyInsuranceSettings($companyId: ID!) {
    companyInsuranceSettings(input: { companyID: $companyId }) {
      active
      price
      salesChannelsV2 {
        id
        name
      }
    }
  }
`
